import { getClientHost, isKzDomain } from './getDomainInfo';

import { LOCALES } from '@/shared/constants/common';
import { Locale } from '@/shared/types';

const YANDEX_METRIKA_CLIENT_ID_TIMEOUT_MS = 500;
const YANDEX_METRIKA_COUNTER_ID = 94774691;

export const getGoogleAnalyticsClientId = (): string | null => {
  if (typeof document === 'undefined') {
    return null;
  }

  try {
    const gaCookie = document.cookie
      .split('; ')
      .find((row) => row.startsWith('_ga='));

    if (!gaCookie) {
      return null;
    }

    const parts = gaCookie.split('=')[1]?.split('.');

    if (!parts || parts.length < 4) {
      return null;
    }

    return `${parts[2]}.${parts[3]}`;
  } catch {
    return null;
  }
};

export const getYandexMetrikaClientId = async (): Promise<string | null> => {
  if (typeof window === 'undefined') {
    return null;
  }

  const ym = window.ym;

  if (!ym) {
    return null;
  }

  return new Promise((resolve) => {
    let isResolved = false;

    const finish = (clientId?: string) => {
      if (isResolved) {
        return;
      }

      isResolved = true;
      resolve(clientId || null);
    };

    window.setTimeout(finish, YANDEX_METRIKA_CLIENT_ID_TIMEOUT_MS);

    try {
      ym(YANDEX_METRIKA_COUNTER_ID, 'getClientID', finish);
    } catch {
      finish();
    }
  });
};

export const getAnalyticsClientId = async (
  locale: Locale,
): Promise<string | null> => {
  /** На КЗ домене независимо от локали приоритет у Google Analytics,
   * Яндекс Метрика — только как фолбэк */
  if (isKzDomain(getClientHost())) {
    return getGoogleAnalyticsClientId() ?? getYandexMetrikaClientId();
  }

  return locale === LOCALES.ru
    ? getYandexMetrikaClientId()
    : getGoogleAnalyticsClientId();
};
